import React, { useState } from 'react'
import { Form, Radio } from 'antd'

const AspectRatioSelector = ({ form, disabled }) => {
  const { getFieldDecorator, setFieldsValue } = form
  const [selectedRatio, setSelectedRatio] = useState('default')

  const handleAspectRatioChange = ratio => {
    setSelectedRatio(ratio)
    setFieldsValue({ aspectRatio: ratio })
  }

  const aspectRatios = [
    { value: 'default', label: 'Square (1:1)', width: 80, height: 80 },
    { value: '16:9', label: 'Landscape (16:9)', width: 106, height: 60 },
    { value: '3:2', label: 'Landscape (3:2)', width: 96, height: 64 },
    { value: '4:3', label: 'Landscape (4:3)', width: 90, height: 68 },
    { value: '2:1', label: 'Landscape (2:1)', width: 112, height: 56 },
    { value: '9:16', label: 'Portrait (9:16)', width: 60, height: 106 },
    { value: '2:3', label: 'Portrait (2:3)', width: 64, height: 96 },
    { value: '3:4', label: 'Portrait (3:4)', width: 68, height: 90 },
    { value: '1:2', label: 'Portrait (1:2)', width: 56, height: 112 }
  ]

  return (
    <Form.Item label="📐 Aspect Ratio" className="aspect-ratio-selector">
      {getFieldDecorator('aspectRatio', {
        initialValue: 'default'
      })(
        <Radio.Group disabled={disabled} className="hidden-radio-group">
          {aspectRatios.map(ratio => (
            <Radio
              key={ratio.value}
              value={ratio.value}
              className="hidden-radio"
            />
          ))}
        </Radio.Group>
      )}

      <div className="aspect-ratio-grid">
        {aspectRatios.map(ratio => (
          <div
            key={ratio.value}
            className={`aspect-ratio-option ${
              selectedRatio === ratio.value ? 'selected' : ''
            }`}
            onClick={() => !disabled && handleAspectRatioChange(ratio.value)}
          >
            <div
              className="aspect-ratio-preview"
              style={{
                width: ratio.width,
                height: ratio.height,
                opacity: disabled ? 0.5 : 1
              }}
            >
              <div className="aspect-ratio-image">
                <div className="aspect-ratio-mountains"></div>
                <div className="aspect-ratio-sky"></div>
              </div>
            </div>
            <div className="aspect-ratio-label">{ratio.label}</div>
          </div>
        ))}
      </div>

      <style jsx>{`
        .aspect-ratio-grid {
          display: grid;
          grid-template-columns: repeat(5, 1fr);
          gap: 16px;
          margin-top: 8px;
        }

        .hidden-radio-group {
          display: none;
        }

        .aspect-ratio-option {
          display: flex;
          flex-direction: column;
          align-items: center;
          cursor: ${disabled ? 'not-allowed' : 'pointer'};
          padding: 8px;
          border-radius: 8px;
          transition: all 0.2s;
        }

        .aspect-ratio-option.selected {
          background-color: rgba(24, 144, 255, 0.1);
          border: 1px solid #1890ff;
        }

        .aspect-ratio-preview {
          position: relative;
          overflow: hidden;
          border: 1px solid #d9d9d9;
          border-radius: 4px;
          box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
          margin-bottom: 8px;
          background: #f5f5f5;
        }

        .aspect-ratio-image {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
        }

        .aspect-ratio-sky {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 60%;
          background: linear-gradient(to bottom, #87ceeb, #add8e6);
        }

        .aspect-ratio-mountains {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          height: 40%;
          background: linear-gradient(to bottom, #6b8e23, #2e8b57);
          clip-path: polygon(0% 100%, 30% 40%, 70% 70%, 100% 20%, 100% 100%);
        }

        .aspect-ratio-label {
          font-size: 12px;
          text-align: center;
          color: rgba(0, 0, 0, 0.65);
        }
      `}</style>
    </Form.Item>
  )
}

export default AspectRatioSelector
